import type TableView from "../store/schema/TableView";
import { type TableQueryType } from "../store/schema/TableQuery";
import type SortBy from "../store/schema/SortBy";
import type MailFolderTableQuery from "../store/schema/MailFolderTableQuery";
import type { CopilotResultsTableQuery } from "../store/schema/CopilotResultsTableQuery";
import type { MyOutlookTableQuery } from "../store/schema/MyOutlookTableQuery";

/**
 * Gets the sort by property for the given table
 * @param tableView for which to find the soryBy
 * @returns the sortBy property for the given table
 */
export default function getSortByForTable(tableView: TableView): SortBy {
    switch (tableView.tableQuery.type) {
        case 0:
        case 2:
        case 3:
            return (tableView.tableQuery as MailFolderTableQuery).sortBy;
        
        case 4:
            return (tableView.tableQuery as CopilotResultsTableQuery).sortBy;
        
        case 5:
            return (tableView.tableQuery as MyOutlookTableQuery).sortBy;
        
        default:
            throw new Error("getSortByForTable: Table Query type should be either of type group, or mail folder");
    }
}
